import { collection, addDoc } from "firebase/firestore";
import { useState } from "react";
import { doorSupervisorQuestions } from "./QuizData";
import { db, logout } from "../firebase/firebaseConfig";
import QuizForm from "./QuizForm";
import ResultPage from "./QuizResult";
import QuizTimer from "./QuizTimer";
import QuizQuestion from "./QuizQuestion";
import "./DoorSupervisorQuizPage.css"; // ✅ Import the CSS

function DoorSupervisorQuizPage() {
    const [user, setUser] = useState(null);
    const [answers, setAnswers] = useState({});
    const [submitted, setSubmitted] = useState(false);

    const handleStart = (formData) => setUser(formData);

    const handleAnswer = (index, answer) =>
        setAnswers((prev) => ({ ...prev, [index]: answer }));

    const handleSubmit = async () => {
        if (!user?.firstName || !user?.lastName || !user?.course || !user?.attempt) {
            alert("Missing user information. Please restart the quiz.");
            return;
        }

        const score = doorSupervisorQuestions.reduce(
            (acc, q, i) => acc + (answers[i] === q.answer ? 1 : 0),
            0
        );

        try {
            await addDoc(collection(db, "quizResults"), {
                firstName: user.firstName,
                lastName: user.lastName,
                course: user.course,
                attempt: user.attempt,
                score,
                total: doorSupervisorQuestions.length,
                timestamp: new Date(),
            });

            setSubmitted(true);
        } catch (error) {
            console.error("Error submitting quiz:", error);
            alert("There was an error saving your results.");
        }
    };

    const handleExpire = () => {
        alert("⏰ Time's up! You have been logged out.");
        logout();
        window.location.href = "/";
    };

    if (!user) return <QuizForm onStart={handleStart} />;
    if (submitted)
        return (
            <ResultPage
                score={doorSupervisorQuestions.reduce(
                    (acc, q, i) => acc + (answers[i] === q.answer ? 1 : 0),
                    0
                )}
                total={doorSupervisorQuestions.length}
            />
        );

    return (
        <div className="quiz-page">
            <div className="quiz-header">
                <h2>🛡️ Door Supervisor Quiz</h2>
                <QuizTimer onExpire={handleExpire} />
            </div>

            <div className="quiz-body">
                {doorSupervisorQuestions.map((q, i) => (
                    <div key={i} className="quiz-question">
                        <QuizQuestion question={q} index={i} onAnswer={handleAnswer} />
                    </div>
                ))}
            </div>

            <div className="quiz-footer">
                <button className="submit-btn" onClick={handleSubmit}>
                    Submit Quiz
                </button>
            </div>
        </div>
    );
}

export default DoorSupervisorQuizPage;
